import React from "react";

/**
 * Binary segmented control for choosing how an email step is sent:
 * "New thread" (replyAsThread=false) vs "Reply in thread" (replyAsThread=true).
 *
 * onChange is called with `{ subKey }` so it can be wired directly to the
 * existing `changeReplyThread` handler, which reads `subKey` (true = reply).
 */
const ThreadSegmentedToggle = ({
  replyAsThread = false,
  onChange,
  label = "Send as"
}) => {
  const select = subKey => {
    if (subKey === replyAsThread) return;
    if (onChange) onChange({ subKey });
  };

  return (
    <div className="drThreadToggle">
      {label && <span className="drThreadToggleLabel">{label}</span>}
      <div className="drThreadSegments">
        <button
          type="button"
          className={`drThreadSegment ${!replyAsThread ? "active" : ""}`}
          aria-pressed={!replyAsThread}
          onClick={() => select(false)}
        >
          New thread
        </button>
        <button
          type="button"
          className={`drThreadSegment ${replyAsThread ? "active" : ""}`}
          aria-pressed={replyAsThread}
          onClick={() => select(true)}
        >
          Reply in thread
        </button>
      </div>
    </div>
  );
};

export default ThreadSegmentedToggle;
